import { Box } from "@mui/material";
import ManpowerCostForm from "../../ChatWindow/ManpowerCostForm";
import styles from "./styles.module.css";

interface ManpowerCostOutcomeProps {
  parsedContent?: any;
}

export default function ManpowerCostOutcome({
  parsedContent,
}: ManpowerCostOutcomeProps): JSX.Element {
  // Extract template URL from parsed content
  const templateUrl = parsedContent?.finalAnswer?.input_template;

  return (
    <Box className={styles.container}>
      <ManpowerCostForm templateUrl={templateUrl} />
    </Box>
  );
}
